export default __webpack_public_path__ + "335ae049c6d2140a21823aeada58bd59.png";